import { Component, Input, OnInit } from '@angular/core';
import { CiudadanosService } from '../../../../services/database/pqrsd/ciudadanos.service';
import { IGetCiudadanosInfo } from '../../../../shared/interfaces/database/pqrsd';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-cuidadano',
  standalone: true,
  imports: [CommonModule, TranslateModule, SkeletonModule],
  templateUrl: './cuidadano.component.html',
  styleUrl: './cuidadano.component.scss'
})
export class CuidadanoComponent implements OnInit {
  @Input() solicitudId !: number;

  ciudadanosInfo!: IGetCiudadanosInfo;
  isLoading: boolean = true;
  trans: any;

  constructor(
    private readonly _cs: CiudadanosService,
    private readonly _t: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      nombre: this._t.get('common.nombre'),
      correo: this._t.get('common.correo'),
      telefono: this._t.get('common.telefono'),
      direccion: this._t.get('common.direccion'),
      identificacion: this._t.get('common.identificacion'),
      tipoIdentificacion: this._t.get('common.tipoIdentificacion'),
      razonSocial: this._t.get('common.razonSocial'),
      tipoPersona: this._t.get('common.tipoPersona'),
      pais: this._t.get('common.pais'),
      departamento: this._t.get('common.departamento'),
      municipio: this._t.get('common.municipio'),
      tipoPoblacion: this._t.get('common.tipoPoblacion'),
      presentaDiscapacidad: this._t.get('msg.presentaDiscapacidad'),
      discapacidad: this._t.get('common.discapacidad')
    }));
  }

  getInformacionCiudadano() {
    this.isLoading = true;
    this._cs.getCiudadanosInfo(this.solicitudId).subscribe({
      next: (data: IGetCiudadanosInfo) => {
        this.ciudadanosInfo = data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
